import { render, staticRenderFns } from "./liveBroadcast.vue?vue&type=template&id=5fc1d5e4&scoped=true&"
import script from "./liveBroadcast.vue?vue&type=script&lang=js&"
export * from "./liveBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./liveBroadcast.vue?vue&type=style&index=0&id=5fc1d5e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1d5e4",
  null
  
)

export default component.exports